import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import ThankYou from "./pages/ThankYou";
import IntroPopup from "./components/IntroPopup";
import Form from "./components/Form";

export default function App() {
  const [showFormPopup, setShowFormPopup] = useState(false);
  const [introShown, setIntroShown] = useState(false);

  useEffect(() => {
    setTimeout(() => setIntroShown(true), 700);
  }, []);

  return (
    <BrowserRouter>
      <div className="app-root bg-black text-light">

        <Routes>
          {/* HOME PAGE */}
          <Route
            path="/"
            element={
              <>
                <Home onOpenForm={() => setShowFormPopup(true)} />

                {/* Intro popup */}
                <IntroPopup
                  show={introShown}
                  onClose={() => setIntroShown(false)}
                  onOpenForm={() => {
                    setShowFormPopup(true);
                    setIntroShown(false);
                  }}
                />

                {/* Form Modal */}
                {showFormPopup && (
                  <div
                    className="modal fade show d-block"
                    tabIndex={-1}
                    style={{ background: "rgba(0,0,0,0.6)" }}
                  >
                    <div className="modal-dialog modal-dialog-centered">
                      <div className="modal-content bg-dark border-0 p-4">
                        <div className="modal-header border-0">
                          <h5 className="modal-title text-white">
                            Enquire Now
                          </h5>
                          <button
                            type="button"
                            className="btn-close btn-close-white"
                            onClick={() => setShowFormPopup(false)}
                          />
                        </div>

                        <div className="modal-body">
                          <Form type="popup" />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            }
          />

          {/* THANK YOU PAGE */}
          <Route path="/thank-you" element={<ThankYou />} />
        </Routes>

      </div>
    </BrowserRouter>
  );
}
